import type { Components, Theme } from "@mui/material";

declare module "@mui/material/Chip" {
	interface ChipPropsColorOverrides {
		white: true;
		muted: true;

		followers: true;
		creators: true;
		knowledge: true;

		// Subscription
		starter: true;
		essentials: true;
		premium: true;

		// Status
		active: true;
		canceled: true;
		expired: true;
		past_due: true;
		unpaid: true;
		paused: true;
	}
}

export const MuiChip: Components<Theme>["MuiChip"] = {
	variants: [
		{
			props: {},
			style: { lineHeight: 1, width: "fit-content" },
		},
		{
			props: { size: "small" },
			style: ({ theme }) => ({
				fontSize: theme.typography.pxToRem(14),
				height: theme.spacing(3.5),
				paddingInline: theme.spacing(0.25),
			}),
		},
		{
			props: { size: "medium" },
			style: ({ theme }) => ({
				fontSize: theme.typography.pxToRem(16),
				height: theme.spacing(4),
				paddingInline: theme.spacing(0.5),
			}),
		},
		{
			props: { variant: "outlined" },
			style: ({ theme }) => ({
				backdropFilter: "blur(6px)",
				borderColor: theme.palette.text.primary,
				color: theme.palette.text.primary,
			}),
		},
		{
			props: { variant: "outlined", color: "followers" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.audiences.background,
				borderColor: theme.palette.audiences.main,
				color: theme.palette.audiences.main,
			}),
		},
		{
			props: { variant: "outlined", color: "creators" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.creators.background,
				borderColor: theme.palette.creators.main,
				color: theme.palette.creators.main,
			}),
		},
		{
			props: { variant: "outlined", color: "knowledge" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.knowledge.background,
				borderColor: theme.palette.knowledge.main,
				color: theme.palette.knowledge.main,
			}),
		},
		{
			props: { color: "white" },
			style: {
				backgroundColor: "transparent",
				borderColor: "white",
				color: "white",
			},
		},
		{
			props: { color: "muted" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.muted.main,
			}),
		},
		{
			props: { color: "active" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.success.background,
				color: theme.palette.success.dark,
			}),
		},
		{
			props: { color: "canceled" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.error.background,
				color: theme.palette.error.dark,
				opacity: 0.75,
			}),
		},
		{
			props: { color: "past_due" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.error.background,
				color: theme.palette.error.dark,
			}),
		},
		{
			props: { color: "paused" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.warning.background,
				color: theme.palette.warning.dark,
			}),
		},
		{
			props: { color: "unpaid" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.warning.background,
				color: theme.palette.warning.dark,
			}),
		},
		...generateSubscriptionColors(),
	],
};

function generateSubscriptionColors() {
	// TODO: precisamos implementar um array global de planos para reutilizar
	const colors = ["starter", "essentials", "premium"] as const;
	return colors.map((color) => ({
		props: { color },
		style: ({ theme }: { theme: Theme }) => ({
			backgroundColor: theme.palette[color].main,
			color: theme.palette[color].contrastText,
		}),
	}));
}
